import $ from 'jquery';

function init() {
  $('.preloaderPage').delay(800).fadeOut('slow');
  $('.preloaderPage__loader').delay(400).fadeOut('slow');
}

module.exports = { init };



/** WEBPACK FOOTER **
 ** ./src/blocks/preloader_page/preloader_page.js
 **/